import pkg from '../package.json' with { type: 'json' }

/**
 * One name for both halves: the SDK tags events with it, and the build uploads
 * sourcemaps under it. These drifted (`rundownstudio@` vs `rundown-studio@`),
 * which put every sourcemap on a release that had no events.
 */
export const SENTRY_RELEASE = 'rundownstudio@' + pkg.version
